import React from "react";
import { Card, Row, Col } from "antd";
import {
  RiseOutlined,
  ThunderboltOutlined,
  ShopOutlined,
  DollarOutlined,
} from "@ant-design/icons";
import SectionTitle from "../SectionTitle/SectionTitle";
import "./B2BBenefits.css";

const benefits = [
  {
    title: "Alta margem por porção",
    text: "Com custo médio a partir de R$ 1,50 por porção, o frozen se transforma em uma sobremesa premium com alto potencial de lucro.",
  },
  {
    title: "Produto fácil de vender",
    text: "Sabores conhecidos, apresentação atrativa e alta aceitação para vender no salão, delivery ou como adicional no pedido.",
  },
  {
    title: "Operação simples",
    text: "Fácil de armazenar, preparar e servir. Sua equipe ganha uma nova sobremesa sem complicar a rotina da cozinha.",
  },
  {
    title: "Aumente o ticket médio",
    text: "Inclua uma sobremesa desejada no cardápio e aumente o valor final de cada mesa com uma venda simples.",
  },
];

const icons = [
  <DollarOutlined />,
  <ThunderboltOutlined />,
  <ShopOutlined />,
  <RiseOutlined />,
];

function B2BBenefits() {
  return (
    <section className="b2b-benefits section" id="beneficios">
      <div className="container">
        <SectionTitle
          eyebrow="Benefícios B2B"
          title="Uma sobremesa pensada para gerar lucro dentro do restaurante"
          description="Produto premium, baixo custo por porção e operação simples para aumentar o faturamento sem complicar a rotina da cozinha."
        />

        <Row gutter={[22, 22]}>
          {benefits.map((item, index) => (
            <Col xs={24} md={12} lg={6} key={item.title}>
              <Card className="b2b-benefits__card">
                <div className="b2b-benefits__icon">{icons[index]}</div>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </section>
  );
}

export default B2BBenefits;